import { render, staticRenderFns } from "./albumErr.vue?vue&type=template&id=54af48f3&scoped=true&"
import script from "./albumErr.vue?vue&type=script&lang=js&"
export * from "./albumErr.vue?vue&type=script&lang=js&"
import style0 from "./albumErr.vue?vue&type=style&index=0&id=54af48f3&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54af48f3",
  null
  
)

export default component.exports